/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View } from 'react-native';
import { formControlContainer } from '@assets/styles/formStyles';
import FormLabel from '@components/form/common/FormLabel';
import FormError from '@components/form/common/FormError';
import FormOverlay from '@components/form/common/FormOverlay';
import FormValueMultiple from '@components/form/common/FormValueMultiple';
import FormInputContainer from '@components/form/common/FormInputContainer';
import PropTypes from 'prop-types';

const propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  labelValue: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  labelKey: PropTypes.string,
  hasError: PropTypes.bool,
  hideLabel: PropTypes.bool,
  editable: PropTypes.bool,
  containerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  inputContainerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

const defaultProps = {
  label: '',
  value: [],
  labelValue: '',
  placeholder: '',
  isRequired: false,
  labelKey: '',
  hasError: false,
  hideLabel: false,
  editable: true,
  containerStyle: {},
  inputContainerStyle: {},
};

const InputClickCallback = (props) => {
  const {
    labelValue = '',
    containerStyle = {},
    editable = true,
    onClick = () => {},
  } = props;

  return (
    <>
      <View style={{ position: 'relative' }}>
        <FormOverlay
          {...props}
          onCallback={() => (editable ? onClick() : false)}
        />
        <View style={[formControlContainer, containerStyle]}>
          <FormLabel {...props} />
          <FormInputContainer {...props} right={10} value={labelValue} />
          <FormError {...props} />
        </View>
        <FormValueMultiple {...props} />
      </View>
    </>
  );
};

InputClickCallback.propTypes = propTypes;
InputClickCallback.defaultProps = defaultProps;

export default React.memo(InputClickCallback, (prev, next) => prev == next);
